import React from 'react';
import { RecoilRoot } from 'recoil';
import Toast from '@powerednow/components/toast/toast';
import { CreateExtComponent } from '@powerednow/client-shared/Components/react/React';
import ThemeEditMenu from 'FieldServices/react/features/themeEditor/themeEditMenu';
import withDataWrapper from 'FieldServices/hooks/withDataWrapper';

function ThemeEdit(props) {
    return (
        <RecoilRoot>
            <ThemeEditMenu {...props} />
            <Toast />
        </RecoilRoot>
    );
}

export default ThemeEdit;
export const ExtThemeEdit = CreateExtComponent('FieldServices.view.settings.layoutwizard.themeEdit', withDataWrapper(ThemeEdit), { alias: 'widget.ExtThemeEdit' });
